// Generated-model previews are CloudFront signed URLs with a canned policy (see
// Generator::SignedAssetUrl): the signature carries an `Expires` epoch and CloudFront
// rejects the request once it passes. Finished-run results live in localStorage for as
// long as the user leaves them unopened, so a persisted previewUrl routinely outlives
// its signature and the image 403s. Consumers use this to re-sign the URL before
// rendering a dead image.
const EXPIRY_SKEW_MS = 60000

// Non-signed URLs (the dev/blob-redirect path, which re-signs per request) have no
// `Expires` and are treated as always valid.
export function isSignedUrlExpired(url, now = Date.now()) {
  if (!url) {
    return false
  }

  let expires
  try {
    expires = new URL(url, 'http://localhost').searchParams.get('Expires')
  } catch {
    return false
  }

  const expiresAtMs = Number(expires) * 1000
  if (!expires || Number.isNaN(expiresAtMs)) {
    return false
  }

  return expiresAtMs - EXPIRY_SKEW_MS <= now
}

export default isSignedUrlExpired
